import {
	Component,
	EventEmitter,
	Input,
	Output,
	ElementRef,
	ViewChild,
} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {NgIf, NgClass} from '@angular/common';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslatePipe} from '@shared/pipes';
import {MiddleTruncateComponent} from '@shared/components/ui/middle-truncate.component';

@Component({
	selector: 'green-editable-title',
	standalone: true,
	imports: [
		FormsModule,
		MatIconModule,
		MatButtonModule,
		NgIf,
		NgClass,
		MatTooltipModule,
		TranslatePipe,
		MiddleTruncateComponent,
	],
	templateUrl: './editable-title.component.html',
	styleUrls: ['./editable-title.component.scss'],
})
export class EditableTitleComponent {
	@Input() value = '';
	@Input() placeholder = '';
	@Input() readonly = false;
	@Input() compact = false;
	@Input() pos: 'start' | 'center' | 'end' = 'start';
	@Input() required = true;
	@Input() customColor = '';
	@Input() maxLength = 30;
	@Output() valueChange = new EventEmitter<string>();

	@ViewChild('titleInput') titleInput!: ElementRef<HTMLInputElement>;

	isEditing = false;
	tempValue = '';

	startEditing(): void {
		if (this.readonly) return;
		this.tempValue = this.value;
		this.isEditing = true;
		setTimeout(() => {
			this.titleInput.nativeElement.focus();
		});
	}

	save(): void {
		const newValue = this.tempValue.trim();
		const canSave = this.required ? !!newValue : true;
		if (canSave && newValue !== this.value) {
			this.value = newValue;
			this.valueChange.emit(newValue);
		}
		this.isEditing = false;
	}

	cancel(): void {
		this.isEditing = false;
		this.tempValue = this.value;
	}
}
